import { AiOutlineFullscreen } from "react-icons/ai"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import useAppContext from "../../hook/useAppContext"

const GallerySlide = ({images}) => {

      const {setObj, modal, setModal} = useAppContext()

      const openImage = (img) => {
            setObj(img)
            setModal(!modal)
      }

      const settings = {
              dots: false,
              infinite: true,
              speed: 600,
              slidesToShow: 3,
              slidesToScroll: 1,
              autoplay: true,
              autoplaySpeed: 2000,
              cssEase: 'ease-in-out',
              initialSlide: 0
      }
      
      return (
            <Slider {...settings}>
                  {
                        images.map((img, index) => (
                              <div className="card_gallery" key={index}>
                                    <div className="card_gallery__img flex">
                                          <img src={img.url} alt={img.title} />
                                    </div>
                                    <div className="card_gallery__inner">
                                          <button className="open_img flex" onClick={() => openImage(img)}><AiOutlineFullscreen /></button>
                                    </div>
                              </div>
                        ))
                  }
            </Slider>
      )
}

export default GallerySlide
